import { render, staticRenderFns } from "./scoring.vue?vue&type=template&id=15ba77d0&scoped=true"
import script from "./scoring.vue?vue&type=script&lang=js"
export * from "./scoring.vue?vue&type=script&lang=js"
import style0 from "./scoring.vue?vue&type=style&index=0&id=15ba77d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba77d0",
  null
  
)

export default component.exports